var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookkeeperImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 241,
    viewBox: "0 0 268 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.138,
    cy: 120.254,
    r: 120,
    fill: "#EAF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6154 121.594C26.2637 91.1484 38.2643 60.6684 62.3074 38.3965C86.3511 16.1242 117.658 6.48591 147.988 9.16171L148.799 8.41036C146.688 8.2114 144.564 8.06411 142.428 7.98258C112.44 6.83618 83.7993 17.4363 61.784 37.83C39.7678 58.2246 27.0113 85.9722 25.8643 115.961C25.7822 118.096 25.7673 120.225 25.804 122.346L26.6154 121.594Z",
    fill: "#2977CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.455 63.9095L235.055 63.3528C230.982 56.4443 226.141 49.9213 220.559 43.8971C212.621 35.3273 203.565 28.1682 193.701 22.543L193.073 23.1241C202.855 28.6491 211.959 35.7488 219.993 44.4213C225.622 50.4961 230.435 57.0389 234.455 63.9095Z",
    fill: "#2977CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.803 106.352C253.084 140.803 241.319 176.77 213.963 202.111C168.827 243.922 98.0897 241.218 56.2784 196.081C48.2442 187.409 41.8605 177.787 37.0994 167.612L36.4713 168.194C41.3276 178.459 47.7736 188.035 55.712 196.604C76.1066 218.622 103.854 231.378 133.842 232.523C163.83 233.672 192.471 223.072 214.487 202.677C236.503 182.283 249.259 154.535 250.406 124.547C250.65 118.171 250.358 111.857 249.558 105.652L248.803 106.352Z",
    fill: "#2977CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0342 75.7957C60.4444 69.576 64.6215 63.6536 69.5866 58.1705C103.118 21.1455 160.028 17.6093 197.869 49.6525L198.365 49.1041C180.254 33.7487 157.356 25.9642 133.526 27.1442C108.656 28.3759 85.7539 39.2183 69.0394 57.6753C63.9812 63.2603 59.6787 69.3428 56.1628 75.7957H57.0342Z",
    fill: "#2977CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8494 114.926H45.0613C44.8793 118.215 44.8629 121.531 45.0283 124.867C46.2083 148.695 56.2161 170.714 73.2861 187.219L73.7822 186.671C53.8073 167.332 44.3749 140.924 45.8494 114.926Z",
    fill: "#2977CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.124 75.7965C219.187 74.0707 218.192 72.3734 217.144 70.707L216.601 71.3051C217.522 72.7813 218.392 74.28 219.223 75.7965H220.124Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M231.203 114.926H230.414C231.797 138.822 223.987 163.236 206.687 182.339C178.342 213.637 133.295 220.997 97.1797 203.173L96.6374 203.772C110.768 210.822 126.542 214.168 142.747 213.364C167.617 212.134 190.518 201.29 207.234 182.835C223.948 164.379 232.476 140.518 231.244 115.647C231.233 115.406 231.217 115.166 231.203 114.926Z",
    fill: "#2977CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.876 212.907C177.235 212.338 178.6 211.734 179.932 211.106L179.617 210.438C178.296 211.061 176.94 211.663 175.592 212.226L175.876 212.907Z",
    fill: "#2977CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2083 179.773L56.6166 180.213C57.4965 181.395 58.4144 182.572 59.3435 183.708L59.9154 183.242C58.9932 182.112 58.0831 180.945 57.2083 179.773Z",
    fill: "#2977CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2704 172.496L51.6414 172.884C52.4122 174.134 53.221 175.386 54.0473 176.603L54.6579 176.188C53.8386 174.98 53.0352 173.738 52.2704 172.496Z",
    fill: "#2977CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5663 148.418L40.8577 148.626C41.2726 150.042 41.7242 151.466 42.1999 152.857L42.8976 152.619C42.4256 151.237 41.9777 149.822 41.5663 148.418Z",
    fill: "#2977CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9208 192.887L68.4155 193.424C69.4873 194.43 70.5987 195.428 71.7169 196.389L72.1975 195.83C71.0876 194.875 69.9848 193.885 68.9208 192.887Z",
    fill: "#2977CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9949 164.809L47.3334 165.138C47.9918 166.455 48.6889 167.777 49.4046 169.064L50.0494 168.705C49.3389 167.427 48.6475 166.116 47.9949 164.809Z",
    fill: "#2977CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4153 156.754L43.7283 157.024C44.2666 158.396 44.8422 159.774 45.4403 161.118L46.1144 160.819C45.5221 159.484 44.9496 158.117 44.4153 156.754Z",
    fill: "#2977CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.542 215.949C168.946 215.505 170.359 215.024 171.742 214.517L171.488 213.824C170.116 214.326 168.713 214.806 167.318 215.246L167.542 215.949Z",
    fill: "#2977CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.133 219.059L150.229 219.792C151.691 219.599 153.167 219.373 154.616 219.117L154.489 218.391C153.048 218.644 151.583 218.869 150.133 219.059Z",
    fill: "#2977CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.811 217.532L158.969 218.253C160.408 217.933 161.859 217.578 163.281 217.197L163.09 216.484C161.679 216.862 160.239 217.216 158.811 217.532Z",
    fill: "#2977CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6019 198.625L75.1463 199.206C76.305 200.116 77.4997 201.013 78.696 201.87L79.1258 201.269C77.9384 200.419 76.7532 199.528 75.6019 198.625Z",
    fill: "#2977CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7641 203.758L82.361 204.376C83.5953 205.181 84.8646 205.969 86.1333 206.72L86.5085 206.084C85.2496 205.339 83.99 204.558 82.7641 203.758Z",
    fill: "#2977CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.071 213.164C100.145 212.803 99.2207 212.433 98.3103 212.047L98.0226 212.726C99.0619 213.168 100.122 213.59 101.18 213.997L101.071 213.164Z",
    fill: "#2977CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3526 208.246L90.0052 208.897C91.3069 209.591 92.6408 210.265 93.9712 210.9L94.289 210.233C92.969 209.602 91.644 208.933 90.3526 208.246Z",
    fill: "#2977CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7733 186.586L62.2227 187.078C63.2031 188.175 64.2217 189.267 65.2493 190.32L65.7776 189.804C64.7569 188.759 63.7463 187.676 62.7733 186.586Z",
    fill: "#2977CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1604 57.086L59.5902 56.6172C58.6537 57.7578 57.7315 58.9327 56.8501 60.1089L57.4415 60.5516C58.3152 59.3846 59.231 58.2186 60.1604 57.086Z",
    fill: "#2977CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9952 43.9609C70.878 44.9158 69.7658 45.9101 68.6886 46.9167L69.193 47.4558C70.2622 46.4567 71.3655 45.4697 72.474 44.5219L71.9952 43.9609Z",
    fill: "#2977CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5152 50.0195C64.4865 51.0698 63.465 52.1579 62.4808 53.2555L63.0298 53.749C64.0074 52.6594 65.0205 51.5782 66.0421 50.5363L65.5152 50.0195Z",
    fill: "#2977CC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3484 38.9648C77.3631 39.6783 76.382 40.4093 75.4271 41.1554L75.8816 41.7368C76.7245 41.0782 77.5887 40.4325 78.4572 39.7986L78.3484 38.9648Z",
    fill: "#2977CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.687 22.2269L119.558 21.5C118.25 21.732 116.932 21.9964 115.628 22.2809L115.725 23.0153C117.038 22.7274 118.368 22.4609 119.687 22.2269Z",
    fill: "#2977CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.397 219.828L141.492 220.562C142.93 220.498 144.385 220.403 145.818 220.279L145.754 219.543C144.311 219.67 142.844 219.765 141.397 219.828Z",
    fill: "#2977CC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2657 63.7148C53.4343 64.9313 52.6186 66.1831 51.8414 67.4351L52.469 67.8244C53.2405 66.5813 54.0498 65.3384 54.8749 64.1306L54.2657 63.7148Z",
    fill: "#2977CC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5837 71.2617C48.8633 72.5456 48.1608 73.8643 47.4962 75.1832L48.155 75.5157C48.8154 74.2068 49.5122 72.8982 50.2271 71.6235L49.5837 71.2617Z",
    fill: "#2977CC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 95.9766C39.3997 97.4081 39.0693 98.8685 38.7747 100.317L39.4988 100.463C39.7908 99.0264 40.1186 97.5772 40.4744 96.1563L39.7578 95.9766Z",
    fill: "#2977CC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5827 79.1953C44.9774 80.5404 44.3941 81.9173 43.8494 83.288L44.5347 83.5604C45.0765 82.2004 45.6553 80.8335 46.2565 79.4985L45.5827 79.1953Z",
    fill: "#2977CC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2976 87.457C41.8138 88.8509 41.3542 90.2749 40.933 91.6892L41.6407 91.9002C42.059 90.4963 42.5146 89.0826 42.9952 87.6988L42.2976 87.457Z",
    fill: "#2977CC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M233.318 149.024C233.742 147.607 234.139 146.164 234.498 144.735L233.782 144.555C233.426 145.974 233.031 147.407 232.611 148.813L233.318 149.024Z",
    fill: "#2977CC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M228.21 79.8821L228.886 79.5838C228.29 78.2382 227.654 76.8871 226.996 75.5664L226.336 75.8954C226.988 77.2063 227.619 78.548 228.21 79.8821Z",
    fill: "#2977CC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M214.436 57.4547L215.008 56.9885C214.077 55.8466 213.11 54.7112 212.132 53.6133L211.581 54.1048C212.552 55.1941 213.512 56.3212 214.436 57.4547Z",
    fill: "#2977CC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.905 209.12C185.203 208.436 186.506 207.711 187.775 206.969L187.402 206.332C186.143 207.069 184.851 207.787 183.561 208.467L183.905 209.12Z",
    fill: "#2977CC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M219.685 64.5035L220.296 64.09C219.472 62.8722 218.609 61.6571 217.732 60.4766L217.139 60.9176C218.01 62.0889 218.866 63.295 219.685 64.5035Z",
    fill: "#2977CC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.439 20.6759L137.44 19.9377C135.969 19.9346 134.476 19.9659 133.002 20.0282L133.034 20.7654C134.496 20.7034 135.978 20.673 137.439 20.6759Z",
    fill: "#2977CC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.042 21.5594L124.256 21.5304C125.711 21.3407 127.185 21.1813 128.638 21.0559L128.573 20.3203C127.11 20.4469 125.627 20.608 124.16 20.7992L123.946 20.827L124.042 21.5594Z",
    fill: "#2977CC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.238 21.0842L146.305 20.3489C144.839 20.2163 143.348 20.1146 141.878 20.0469L141.843 20.7836C143.305 20.8513 144.782 20.9521 146.238 21.0842Z",
    fill: "#2977CC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M171.974 26.9614L172.234 26.2701C170.847 25.7516 169.435 25.2586 168.035 24.8047L167.807 25.5069C169.197 25.9568 170.598 26.4466 171.974 26.9614Z",
    fill: "#2977CC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.578 24.2398L163.774 23.5278C162.356 23.1362 160.903 22.771 159.46 22.4414L159.296 23.1615C160.727 23.4873 162.169 23.8508 163.578 24.2398Z",
    fill: "#2977CC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M154.967 22.2694L155.101 21.5436C153.649 21.2797 152.173 21.0455 150.716 20.8477L150.617 21.5789C152.064 21.7759 153.528 22.0084 154.967 22.2694Z",
    fill: "#2977CC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M224.286 71.9986L224.93 71.6403C224.216 70.353 223.465 69.0667 222.698 67.8164L222.069 68.2028C222.83 69.444 223.576 70.7213 224.286 71.9986Z",
    fill: "#2977CC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M211.73 187.436C212.714 186.339 213.688 185.208 214.624 184.07L214.053 183.602C213.125 184.73 212.158 185.854 211.18 186.941L211.73 187.436Z",
    fill: "#2977CC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M217.367 180.582C218.25 179.406 219.122 178.193 219.955 176.976L219.347 176.559C218.519 177.767 217.655 178.972 216.778 180.139L217.367 180.582Z",
    fill: "#2977CC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M222.382 173.255C223.162 172.003 223.922 170.716 224.646 169.433L224.002 169.07C223.285 170.345 222.529 171.622 221.757 172.864L222.382 173.255Z",
    fill: "#2977CC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M191.547 204.651C192.781 203.854 194.015 203.018 195.215 202.165L194.788 201.562C193.595 202.41 192.371 203.241 191.147 204.03L191.547 204.651Z",
    fill: "#2977CC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M226.737 165.515C227.403 164.199 228.048 162.85 228.656 161.507L227.981 161.203C227.38 162.537 226.739 163.876 226.079 165.183L226.737 165.515Z",
    fill: "#2977CC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M198.769 199.517C199.928 198.615 201.083 197.672 202.205 196.715L201.726 196.152C200.612 197.104 199.466 198.039 198.316 198.936L198.769 199.517Z",
    fill: "#2977CC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M205.514 193.765C206.592 192.76 207.661 191.718 208.691 190.67L208.163 190.152C207.141 191.194 206.08 192.228 205.01 193.225L205.514 193.765Z",
    fill: "#2977CC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M235.598 105.187L236.328 105.075C236.104 103.611 235.846 102.141 235.561 100.703L234.837 100.846C235.119 102.274 235.376 103.733 235.598 105.187Z",
    fill: "#2977CC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M230.392 157.42C230.939 156.051 231.463 154.649 231.949 153.254L231.251 153.012C230.769 154.395 230.25 155.787 229.706 157.145L230.392 157.42Z",
    fill: "#2977CC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M231.418 88.0859L232.118 87.8478C231.643 86.4534 231.129 85.0503 230.593 83.6797L229.906 83.9478C230.439 85.3096 230.947 86.7006 231.418 88.0859Z",
    fill: "#2977CC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M233.886 96.5481L234.603 96.3732C234.254 94.9443 233.868 93.5014 233.455 92.0859L232.745 92.2927C233.156 93.698 233.54 95.1295 233.886 96.5481Z",
    fill: "#2977CC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M237.288 113.902C237.195 112.439 237.064 110.952 236.904 109.48L236.17 109.561C236.329 111.021 236.457 112.498 236.552 113.95L237.288 113.902Z",
    fill: "#2977CC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M235.485 140.393C235.78 138.95 236.046 137.481 236.277 136.025L235.547 135.91C235.319 137.354 235.055 138.814 234.763 140.246L235.485 140.393Z",
    fill: "#2977CC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M236.871 131.63C237.037 130.168 237.171 128.681 237.271 127.21L236.534 127.16C236.434 128.62 236.303 130.095 236.138 131.548L236.871 131.63Z",
    fill: "#2977CC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M237.473 122.774C237.508 121.301 237.509 119.807 237.479 118.336L236.741 118.352C236.771 119.812 236.769 121.294 236.736 122.757L237.473 122.774Z",
    fill: "#2977CC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M149.457 5.28906H93.256V35.7159H149.457V5.28906Z",
    fill: "#2977CC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9153 6.79297H147.798V34.2095H94.9153V6.79297Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4057 25.6902C100.404 25.6902 103.741 29.0243 103.749 33.0225H139.228C139.309 29.1461 142.507 25.9351 146.376 25.8309V15.3646C142.4 15.3284 139.092 12.0049 139.092 8.02106C139.092 8.00527 139.096 7.99092 139.096 7.97656H103.743C103.743 8.0337 103.751 8.09054 103.751 8.15055C103.751 12.1551 100.408 15.4972 96.4054 15.4972C96.3816 15.4972 96.3612 15.4923 96.3374 15.4923V25.6945C96.3612 25.6934 96.3819 25.6902 96.4057 25.6902Z",
    fill: "#4D8ED5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M130.293 20.4955C130.293 15.5674 126.284 11.5586 121.357 11.5586C116.429 11.5586 112.418 15.5674 112.418 20.4955C112.418 25.4236 116.429 29.4344 121.357 29.4344C126.284 29.4344 130.293 25.4239 130.293 20.4955Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M113.217 20.5666C113.217 16.1044 116.835 12.4844 121.301 12.4844C125.766 12.4844 129.385 16.1044 129.385 20.5666C129.385 25.0316 125.766 28.6537 121.301 28.6537C116.835 28.6537 113.217 25.0316 113.217 20.5666Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M136.891 19.9258H132.792V21.073H136.891V19.9258Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M142.466 19.9258H138.368V21.073H142.466V19.9258Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M104.915 19.9258H100.816V21.073H104.915V19.9258Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M110.489 19.9258H106.39V21.073H110.489V19.9258Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M118.019 211.634C118.019 223.232 108.616 232.633 97.0214 232.633C85.4217 232.633 76.0198 223.232 76.0198 211.634C76.0198 200.035 85.4217 190.633 97.0214 190.633C108.616 190.633 118.019 200.035 118.019 211.634Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.45289,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M112.95 211.628C112.95 220.429 105.82 227.564 97.0206 227.564C88.2201 227.564 81.086 220.43 81.086 211.628C81.086 202.83 88.2201 195.695 97.0206 195.695C105.82 195.695 112.95 202.829 112.95 211.628Z",
    fill: "#4D8ED5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5721 209.966C95.9787 209.877 94.077 209.484 94.077 208.114C94.077 206.572 95.1502 205.689 97.019 205.689C98.6414 205.689 99.9611 206.779 99.9611 208.114H104.676C104.676 205.422 102.271 203.149 99.0099 202.48V200.691H95.0483V202.442C91.6197 203.039 89.36 205.204 89.36 208.114C89.36 211.04 92.4409 213.1 97.2053 213.367C99.51 213.495 99.9603 214.143 99.9603 215.217C99.9603 216.311 98.6045 217.643 97.0182 217.643C95.3967 217.643 94.0762 216.556 94.0762 215.217H89.36C89.36 217.916 91.7771 220.194 95.0483 220.859V222.557H99.0099V220.835C102.194 220.129 104.676 217.806 104.676 215.218C104.676 212.132 102.086 210.218 97.5721 209.966Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M266.56 79.6571C266.56 91.2552 257.158 100.656 245.563 100.656C233.963 100.656 224.561 91.2552 224.561 79.6571C224.561 68.0581 233.963 58.6562 245.563 58.6562C257.158 58.6562 266.56 68.0581 266.56 79.6571Z",
    fill: "#2977CC",
    stroke: "#83B0E1",
    strokeWidth: 1.45289,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M261.492 79.6518C261.492 88.4524 254.361 95.5872 245.562 95.5872C236.761 95.5872 229.627 88.4532 229.627 79.6518C229.627 70.8536 236.761 63.7188 245.562 63.7188C254.361 63.7188 261.492 70.8528 261.492 79.6518Z",
    fill: "#4D8ED5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M246.113 77.9898C244.52 77.9007 242.618 77.5074 242.618 76.1379C242.618 74.5958 243.691 73.712 245.56 73.712C247.183 73.712 248.502 74.8021 248.502 76.1379H253.217C253.217 73.4455 250.813 71.1729 247.551 70.5034V68.7148H243.59V70.4656C240.161 71.0621 237.901 73.2279 237.901 76.1371C237.901 79.0631 240.982 81.123 245.747 81.3903C248.051 81.518 248.502 82.1666 248.502 83.2407C248.502 84.334 247.146 85.6666 245.559 85.6666C243.938 85.6666 242.617 84.5796 242.617 83.2407H237.901C237.901 85.9395 240.318 88.2177 243.59 88.8824V90.5802H247.551V88.8583C250.736 88.1527 253.217 85.8295 253.217 83.2415C253.218 80.1557 250.627 78.2419 246.113 77.9898Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M180.117 208.041C180.117 209.925 181.643 211.453 183.528 211.453H232.986C234.868 211.453 236.394 209.925 236.394 208.041V179.153C236.394 177.269 234.868 175.742 232.986 175.742H183.528C181.643 175.742 180.117 177.269 180.117 179.153V208.041Z",
    fill: "#2977CC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M236.394 179.508H180.117V184.428H236.394V179.508Z",
    fill: "#161D21"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M233.182 192.871H193.235V198.141H233.182V192.871Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M233.182 189.723H193.235V191.007H233.182V189.723Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M187.479 205.072C187.479 203.242 188.962 201.758 190.793 201.758C192.623 201.758 194.107 203.242 194.107 205.072C194.107 206.902 192.623 208.386 190.793 208.386C188.962 208.386 187.479 206.902 187.479 205.072Z",
    fill: "#83B0E1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M183.668 205.072C183.668 203.242 185.151 201.758 186.982 201.758C188.812 201.758 190.295 203.242 190.295 205.072C190.295 206.902 188.812 208.386 186.982 208.386C185.151 208.386 183.668 206.902 183.668 205.072Z",
    fill: "#EAF1FA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5587 160.022C41.5587 160.022 40.3701 162.234 48.8075 164.077H225.457C225.457 164.077 231.367 163.699 232.923 160.912L232.933 159.387L41.5587 160.022Z",
    fill: "#B0B0B0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5994 155.555H232.995V160.469C232.995 160.469 233.283 161.128 231.029 160.963H43.4015C43.4015 160.963 41.6387 161.458 41.4745 160.307L41.5994 155.555Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M224.105 158.419C224.105 158.609 223.979 158.762 223.821 158.762H217.309C217.151 158.762 217.026 158.609 217.026 158.419C217.026 158.226 217.151 158.07 217.309 158.07H223.821C223.979 158.07 224.105 158.226 224.105 158.419Z",
    fill: "#B0B0B0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M124.297 155.59C124.297 155.59 123.559 158.051 126.018 158.296H148.222C148.222 158.296 150.584 158.602 150.269 155.674L124.297 155.59Z",
    fill: "#B0B0B0"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M150.154 155.73V155.672H150.151C150.151 155.69 150.151 155.709 150.154 155.73Z",
    fill: "url(#paint0_linear_3652_11436)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M214.177 155.53V68.2928C214.177 64.3323 210.938 61.0938 206.98 61.0938H67.5054C63.5465 61.0938 60.3074 64.3323 60.3074 68.2928V155.529L214.177 155.53Z",
    fill: "#161D21"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M209.227 66.4961H65.256V150.177H209.227V66.4961Z",
    fill: "#EAF1FA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M110.823 89.7305H96.4679V135.83H110.823V89.7305Z",
    fill: "#A7C7EA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M144.534 89.7305H130.182V135.83H144.534V89.7305Z",
    fill: "#A7C7EA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M178.331 89.7305H163.975V135.83H178.331V89.7305Z",
    fill: "#A7C7EA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6138 87.8047V91.0848C92.6138 93.2992 94.4177 95.1066 96.6321 95.1066H110.577C112.792 95.1066 114.596 93.2992 114.596 91.0848V87.8047H92.6138Z",
    fill: "#2977CC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M126.409 87.8047V91.0848C126.409 93.2992 128.212 95.1066 130.427 95.1066H144.453C146.667 95.1066 148.473 93.2992 148.473 91.0848V87.8047H126.409Z",
    fill: "#2977CC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M160.12 87.8047V91.0848C160.12 93.2992 161.924 95.1066 164.14 95.1066H178.168C180.381 95.1066 182.185 93.2992 182.185 91.0848V87.8047H160.12Z",
    fill: "#2977CC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M197.497 82.3959L137.236 51.4023L76.9742 82.3959H76.8234V82.4723L76.8051 82.482H76.8234V88.5304H197.677V82.3959H197.497Z",
    fill: "#A7C7EA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0062 80.687L137.236 61.0664L175.464 80.687H99.0062Z",
    fill: "#2977CC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M189.803 138.605H84.6688V144.741H189.803V138.605Z",
    fill: "#A7C7EA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M195.206 144.465H79.2653V150.6H195.206V144.465Z",
    fill: "#2977CC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M114.596 135.527H92.6138V138.706H114.596V135.527Z",
    fill: "#2977CC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M148.391 135.527H126.327V138.706H148.391V135.527Z",
    fill: "#2977CC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M182.102 135.527H160.12V138.706H182.102V135.527Z",
    fill: "#2977CC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M142.901 71.9724C142.901 75.0993 140.367 77.6338 137.241 77.6338C134.115 77.6338 131.58 75.099 131.58 71.9724C131.58 68.847 134.115 66.3125 137.241 66.3125C140.367 66.3122 142.901 68.847 142.901 71.9724Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7511 87.4383C47.1453 85.563 47.2286 83.6282 46.6087 81.7942C45.895 79.6828 43.6082 79.6406 43.6082 79.6406H11.915V87.4383H46.7511Z",
    fill: "#DEDEDF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2449 129.979C41.2449 134.479 39.1998 137.426 35.0793 137.426C24.6742 137.426 5.50177 137.426 5.50177 137.426C5.50177 137.426 5.50177 97.9003 5.50177 84.2285C5.50177 81.369 6.4828 79.6406 9.52034 79.6406C16.1309 79.6406 37.1017 79.6406 43.7771 79.6406C40.9236 80.1273 41.2449 84.6928 41.2449 84.6928C41.2449 84.6928 41.2449 115.442 41.2449 129.979Z",
    fill: "white",
    stroke: "#DEDEDF",
    strokeWidth: 0.217138,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9239 103.066H10.5834H9.13556V106.902H10.5834H10.9239H11.7686V103.066H10.9239Z",
    fill: "#2977CC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7754 95.668H13.4361H12.5911V109.311H13.4361H13.7754H15.2247V95.668H13.7754Z",
    fill: "#2977CC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1353 106.391H16.7951H15.951V110.029H16.7951H17.1353H18.584V106.391H17.1353Z",
    fill: "#2977CC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5908 99.9844H20.2521H19.4083V107.423H20.2521H20.5908H22.041V99.9844H20.5908Z",
    fill: "#2977CC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8547 102.492H23.5159H22.6721V109.313H23.5159H23.8547H25.304V102.492H23.8547Z",
    fill: "#D88150"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2157 98.3828H26.8758H26.0317V107.36H26.8758H27.2157H28.6638V98.3828H27.2157Z",
    fill: "#D88150"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7018 95.668H30.3622H29.5175V106.445H30.3622H30.7018H32.1505V95.668H30.7018Z",
    fill: "#D88150"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1019 96.9922H33.7611H32.9179V109.313H33.7611H34.1019H35.5506V96.9922H34.1019Z",
    fill: "#D88150"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5511 110.156H32.9175V112.871H35.5511V110.156Z",
    fill: "#2977CC"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0945 107.289H29.4618V112.869H32.0945V107.289Z",
    fill: "#2977CC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7348 108.199H26.1021V112.868H28.7348V108.199Z",
    fill: "#2977CC"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2783 110.156H22.6456V112.871H25.2783V110.156Z",
    fill: "#2977CC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M22.014 108.27H19.3824V112.872H22.014V108.27Z",
    fill: "#D88150"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6538 110.875H16.0211V112.874H18.6538V110.875Z",
    fill: "#D88150"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1682 110.156H12.5352V112.871H15.1682V110.156Z",
    fill: "#D88150"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7677 107.746H9.13556V112.871H11.7677V107.746Z",
    fill: "#D88150"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0726 135.272C32.4533 133.438 32.536 131.504 32.9313 129.629H1.22431C0.829547 131.504 0.746862 133.438 1.367 135.272C2.07988 137.384 4.36665 137.427 4.36665 137.427H36.0605V137.425C35.9272 137.423 33.7645 137.319 33.0726 135.272Z",
    fill: "#EAF1FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3652_11436",
    x1: 150.152,
    y1: 155.73,
    x2: 150.152,
    y2: 155.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0244,
    stopColor: "#5F6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4756,
    stopColor: "#676B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#717576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6192,
    stopColor: "#878A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7202,
    stopColor: "#949899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#999C9D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookkeeperImg2);
export default __webpack_public_path__ + "static/media/bookkeeperImg2.c21bcf43430a2f74742d83cdc43ddf73.svg";
export { ForwardRef as ReactComponent };